import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Chip,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  IconButton,
  Tooltip,
  // Dialog,
  // DialogTitle,
  // DialogContent,
  // DialogActions,
  // TextField,
  // FormControl,
  // InputLabel,
  // Select,
  // MenuItem,
  Alert,
  Snackbar,
  Badge,
  //Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab
} from '@mui/material';
import {
  Timeline as TimelineIcon,
  //Assignment as AssignmentIcon,
  Comment as CommentIcon,
  CheckCircle as ApproveIcon,
  Pending as PendingIcon,
  Error as ErrorIcon,
  PlayArrow as StartIcon,
  Stop as StopIcon,
  Refresh as RefreshIcon,
  Visibility as ViewIcon,
  Edit as EditIcon,
  Send as SendIcon,
  Group as GroupIcon,
  Person as PersonIcon,
  ExpandMore as ExpandMoreIcon,
  Notifications as NotificationsIcon,
  History as HistoryIcon,
  Analytics as AnalyticsIcon
} from '@mui/icons-material';
import PageHeader from '../common/PageHeader';
import LoadingState from '../common/LoadingState';
import ErrorState from '../common/ErrorState';
import { getDocumentAuditLog } from '../../services/auditLog.service';

const WorkflowDashboard = ({ documentId, currentUser }) => {
  const [workflowData, setWorkflowData] = useState(null);
  const [statistics, setStatistics] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  // const [openDialog, setOpenDialog] = useState(false);
  // const [dialogType, setDialogType] = useState('');
  // const [selectedUsers, setSelectedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const [auditEntries, setAuditEntries] = useState([]);
  const [auditLoading, setAuditLoading] = useState(false);
  const [auditLoaded, setAuditLoaded] = useState(false);

  const getUserFullName = (user) => {
    if (!user) return 'Unknown User';
    if (typeof user === 'string') return `User ${user.slice(-6)}`;
    if (typeof user?.name === 'string' && user.name.trim()) return user.name.trim();
    const first = (user.firstName || '').toString().trim();
    const last = (user.lastName || '').toString().trim();
    const combined = `${first} ${last}`.trim();
    if (combined) return combined;
    if (user.email) return user.email;
    if (user.username) return user.username;
    if (user._id) return `User ${user._id.toString().slice(-6)}`;
    return 'Unknown User';
  };

  const getUserInitials = (user) => {
    const full = getUserFullName(user);
    const parts = full
      .replace(/[^a-zA-Z0-9@\s._-]/g, ' ')
      .split(/\s+/)
      .filter(Boolean);
    if (parts.length === 0) return 'U';
    if (parts.length === 1) {
      const p = parts[0];
      const emailPrefix = p.includes('@') ? p.split('@')[0] : p;
      return (emailPrefix[0] || 'U').toUpperCase();
    }
    return `${parts[0][0] || 'U'}${parts[1][0] || ''}`.toUpperCase();
  };

  const workflowStates = {
    draft: { label: 'Draft', color: 'default', icon: EditIcon },
    coAuthoring: { label: 'Co-Authoring', color: 'primary', icon: GroupIcon },
    reviewing: { label: 'Reviewing', color: 'warning', icon: CommentIcon },
    aiUpdating: { label: 'AI Updating', color: 'info', icon: RefreshIcon },
    approved: { label: 'Approved', color: 'success', icon: ApproveIcon },
    rejected: { label: 'Rejected', color: 'error', icon: ErrorIcon },
    published: { label: 'Published', color: 'success', icon: ApproveIcon }
  };

  useEffect(() => {
    loadWorkflowData();
    loadStatistics();
    setAuditLoaded(false);
    setAuditEntries([]);
  }, [documentId]);

  useEffect(() => {
    if (selectedTab !== 4 || auditLoaded || !documentId) return;
    let cancelled = false;
    setAuditLoading(true);
    getDocumentAuditLog(documentId)
      .then((res) => {
        if (!cancelled) setAuditEntries(res?.data?.entries || []);
      })
      .catch((err) => {
        console.error('Error loading document audit history:', err);
      })
      .finally(() => {
        if (!cancelled) {
          setAuditLoading(false);
          setAuditLoaded(true);
        }
      });
    return () => { cancelled = true; };
  }, [selectedTab, documentId, auditLoaded]);

  const loadWorkflowData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`/api/documents/${documentId}/workflow`);
      if (response.ok) {
        const data = await response.json();
        setWorkflowData(data);
      }
    } catch (error) {
      console.error('Error loading workflow data:', error);
      showSnackbar('Error loading workflow data', 'error');
    } finally {
      setLoading(false);
    }
  };

  const loadStatistics = async () => {
    try {
      const response = await fetch(`/api/documents/${documentId}/statistics`);
      if (response.ok) {
        const data = await response.json();
        setStatistics(data.statistics);
      }
    } catch (error) {
      console.error('Error loading statistics:', error);
    }
  };

  const showSnackbar = (message, severity = 'info') => {
    setSnackbar({ open: true, message, severity });
  };

  // const openUserDialog = (type) => {
  //   setDialogType(type);
  //   setOpenDialog(true);
  // };

  // const handleUserSelection = async () => {
  //   try {
  //     const endpoint = dialogType === 'coAuthors' ? 'co-authors' : 'reviewers';
  //     const response = await fetch(`/api/documents/${documentId}/workflow/${endpoint}`, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ users: selectedUsers })
  //     });

  //     if (response.ok) {
  //       setOpenDialog(false);
  //       setSelectedUsers([]);
  //       showSnackbar(`${dialogType === 'coAuthors' ? 'Co-authors' : 'Reviewers'} assigned successfully`);
  //       loadWorkflowData();
  //     }
  //   } catch (error) {
  //     console.error('Error assigning users:', error);
  //     showSnackbar('Error assigning users', 'error');
  //   }
  // };

  const handleWorkflowAction = async (action) => {
    try {
      setLoading(true);
      const response = await fetch(`/api/documents/${documentId}/workflow/${action}`, {
        method: 'POST'
      });

      if (response.ok) {
        showSnackbar(`Document ${action} successfully`);
        loadWorkflowData();
      }
    } catch (error) {
      console.error(`Error ${action} document:`, error);
      showSnackbar(`Error ${action} document`, 'error');
    } finally {
      setLoading(false);
    }
  };

  const getWorkflowProgress = () => {
    if (!workflowData) return 0;
    
    const states = ['draft', 'coAuthoring', 'reviewing', 'aiUpdating', 'approved'];
    const currentIndex = states.indexOf(workflowData.state);
    return ((currentIndex + 1) / states.length) * 100;
  };

  const getWorkflowActions = () => {
    if (!workflowData) return [];

    const actions = [];
    
    switch (workflowData.state) {
      case 'draft':
        //if (workflowData.coAuthors && workflowData.coAuthors.length > 0) {
          actions.push({
            label: 'Send for Co-Authoring',
            action: 'co-authoring',
            color: 'primary',
            icon: GroupIcon
          });
        break;
        
      case 'coAuthoring':
        //if (workflowData.reviewers && workflowData.reviewers.length > 0) {
          actions.push({
            label: 'Send for Review',
            action: 'review',
            color: 'warning',
            icon: CommentIcon
          });
        break;
        
      case 'reviewing':
        actions.push({
          label: 'Request AI Updates',
          action: 'ai-update',
          color: 'info',
          icon: RefreshIcon
        });
        actions.push({
          label: 'Send for Approval',
          action: 'approve',
          color: 'success',
          icon: ApproveIcon
        });
        break;
        
      case 'aiUpdating':
        actions.push({
          label: 'Preview Document',
          action: 'preview',
          color: 'primary',
          icon: ViewIcon
        });
        break;
    }
    
    return actions;
  };

  const renderWorkflowTimeline = () => {
    if (!workflowData || !workflowData.history) return null;

    return (
      <List>
        {workflowData.history.map((entry, index) => (
          <ListItem key={index} alignItems="flex-start">
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: 'primary.main' }}>
                <TimelineIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={entry.action}
              secondary={
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    {entry.user?.firstName} {entry.user?.lastName}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {new Date(entry.timestamp).toLocaleString()}
                  </Typography>
                  {entry.details && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      {entry.details}
                    </Typography>
                  )}
                </Box>
              }
            />
          </ListItem>
        ))}
      </List>
    );
  };

  const renderApprovalStatus = () => {
    if (!workflowData || !workflowData.approvals) return null;

    const approvals = workflowData.approvals;
    const total = approvals.length;
    const approved = approvals.filter(a => a.status === 'approved').length;
    const rejected = approvals.filter(a => a.status === 'rejected').length;
    const pending = total - approved - rejected;

    return (
      <Box>
        <Typography variant="h6" gutterBottom>
          Approval Status
        </Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={4}>
            <Box textAlign="center">
              <Typography variant="h4" color="success.main">
                {approved}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Approved
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box textAlign="center">
              <Typography variant="h4" color="warning.main">
                {pending}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Pending
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box textAlign="center">
              <Typography variant="h4" color="error.main">
                {rejected}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Rejected
              </Typography>
            </Box>
          </Grid>
        </Grid>
        
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Reviewer</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Comments</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {approvals.map((approval, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {approval.reviewer?.firstName} {approval.reviewer?.lastName}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={approval.status}
                      color={
                        approval.status === 'approved' ? 'success' :
                        approval.status === 'rejected' ? 'error' : 'warning'
                      }
                      size="small"
                    />
                  </TableCell>
                  <TableCell>{approval.comments || '-'}</TableCell>
                  <TableCell>
                    {new Date(approval.timestamp).toLocaleDateString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  if (loading) {
    return (
      <Box sx={{ p: 3 }}>
        <LoadingState label="Loading workflow data…" />
      </Box>
    );
  }

  if (!workflowData) {
    return (
      <Box sx={{ p: 3 }}>
        <ErrorState title="No workflow data available" />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <PageHeader
        title="Workflow Dashboard"
        subtitle={`Document ID: ${documentId}`}
        actions={
          <Chip
            label={workflowStates[workflowData.state]?.label}
            color={workflowStates[workflowData.state]?.color}
            icon={workflowStates[workflowData.state]?.icon ? React.createElement(workflowStates[workflowData.state].icon) : undefined}
          />
        }
      />

      {/* Progress Bar */}
      <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Workflow Progress
        </Typography>
        <LinearProgress 
          variant="determinate" 
          value={getWorkflowProgress()} 
          sx={{ height: 10, borderRadius: 5 }}
        />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {Math.round(getWorkflowProgress())}% Complete
        </Typography>
      </Paper>

      {/* Statistics Cards */}
      {statistics && (
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} md={3}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <CommentIcon color="primary" sx={{ mr: 1 }} />
                  <Box>
                    <Typography variant="h4">{statistics.totalComments}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Total Comments
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <GroupIcon color="primary" sx={{ mr: 1 }} />
                  <Box>
                    <Typography variant="h4">{statistics.totalCoAuthors}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Co-Authors
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <CommentIcon color="primary" sx={{ mr: 1 }} />
                  <Box>
                    <Typography variant="h4">{statistics.totalReviewers}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Reviewers
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <HistoryIcon color="primary" sx={{ mr: 1 }} />
                  <Box>
                    <Typography variant="h4">
                      {Math.round(statistics.workflowDuration / (1000 * 60 * 60 * 24))}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Days Active
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {/* Main Content */}
      <Grid container spacing={3}>
        {/* Workflow Actions */}
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Workflow Actions
            </Typography>
            <Box sx={{ mb: 2 }}>
              {getWorkflowActions().map((action, index) => (
                <Button
                  key={index}
                  fullWidth
                  variant="contained"
                  color={action.color}
                  startIcon={<action.icon />}
                  onClick={() => handleWorkflowAction(action.action)}
                  sx={{ mb: 1 }}
                >
                  {action.label}
                </Button>
              ))}
            </Box>
            
            {/* <Divider sx={{ my: 2 }} />
            
            <Typography variant="subtitle2" gutterBottom>
              User Management
            </Typography>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<GroupIcon />}
              onClick={() => openUserDialog('coAuthors')}
              sx={{ mb: 1 }}
            >
              Manage Co-Authors
            </Button>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<AssignmentIcon />}
              onClick={() => openUserDialog('reviewers')}
            >
              Manage Reviewers
            </Button> */}
          </Paper>
        </Grid>

        {/* Main Content Area */}
        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 2 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
              <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)}>
                <Tab label="Timeline" icon={<TimelineIcon />} />
                <Tab label="Approvals" icon={<ApproveIcon />} />
                <Tab label="Participants" icon={<GroupIcon />} />
                <Tab label="Analytics" icon={<AnalyticsIcon />} />
                <Tab label="History" icon={<HistoryIcon />} />
              </Tabs>
            </Box>

            {/* Tab Content */}
            {selectedTab === 0 && (
              <Box>
                <Typography variant="h6" gutterBottom>
                  Workflow Timeline
                </Typography>
                {renderWorkflowTimeline()}
              </Box>
            )}

            {selectedTab === 1 && (
              <Box>
                {renderApprovalStatus()}
              </Box>
            )}

            {selectedTab === 2 && (
              <Box>
                <Typography variant="h6" gutterBottom>
                  Participants
                </Typography>
                
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1">Co-Authors ({workflowData.coAuthors?.length || 0})</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <List dense>
                      {workflowData.coAuthors?.map((author, index) => (
                        <ListItem key={index}>
                          <ListItemAvatar>
                            <Avatar>{getUserInitials(author)}</Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={getUserFullName(author)}
                            secondary={typeof author === 'object' ? (author?.email || author?.role || null) : null}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1">Reviewers ({workflowData.reviewers?.length || 0})</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <List dense>
                      {workflowData.reviewers?.map((reviewer, index) => (
                        <ListItem key={index}>
                          <ListItemAvatar>
                            <Avatar>{getUserInitials(reviewer)}</Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={getUserFullName(reviewer)}
                            secondary={typeof reviewer === 'object' ? (reviewer?.email || reviewer?.role || null) : null}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
              </Box>
            )}

            {selectedTab === 3 && (
              <Box>
                <Typography variant="h6" gutterBottom>
                  Analytics
                </Typography>
                <Alert severity="info">
                  Analytics features coming soon. This will include detailed metrics about workflow efficiency,
                  review times, and participant engagement.
                </Alert>
              </Box>
            )}

            {selectedTab === 4 && (
              <Box>
                <Typography variant="h6" gutterBottom>
                  Document History
                </Typography>
                {auditLoading ? (
                  <LoadingState label="Loading history…" compact />
                ) : auditEntries.length === 0 ? (
                  <Alert severity="info">No audit history recorded for this document yet.</Alert>
                ) : (
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Timestamp</TableCell>
                          <TableCell>Entity</TableCell>
                          <TableCell>Action</TableCell>
                          <TableCell>By</TableCell>
                          <TableCell>Summary</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {auditEntries.map((entry) => (
                          <TableRow key={entry._id}>
                            <TableCell>{new Date(entry.createdAt).toLocaleString()}</TableCell>
                            <TableCell>{entry.entityType}</TableCell>
                            <TableCell>
                              <Chip size="small" label={entry.action} />
                            </TableCell>
                            <TableCell>{getUserFullName(entry.actor?.userId) || entry.actor?.role || 'Unknown'}</TableCell>
                            <TableCell>{entry.summary}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Box>
            )}
          </Paper>
        </Grid>
      </Grid>

      {/* User Selection Dialog */}
      {/* <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          {dialogType === 'coAuthors' ? 'Assign Co-Authors' : 'Assign Reviewers'}
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mt: 1 }}>
            <InputLabel>Select Users</InputLabel>
            <Select
              multiple
              value={selectedUsers}
              onChange={(e) => setSelectedUsers(e.target.value)}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
            >
              <MenuItem value="user1">John Doe (Author)</MenuItem>
              <MenuItem value="user2">Jane Smith (Reviewer)</MenuItem>
              <MenuItem value="user3">Bob Johnson (Editor)</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button onClick={handleUserSelection} variant="contained">
            Assign
          </Button>
        </DialogActions>
      </Dialog> */}

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default WorkflowDashboard; 